import { MapProvider } from 'react-map-gl';

export const withMap =
  <P extends object>(Component: React.ComponentType<P>): React.FC<P> =>
  (props) => (
    <MapProvider>
      <Component {...props} />
    </MapProvider>
  );
